import React from 'react';
import { PaperProps } from './Paper/Paper';
import Stack, { contentStackSpacing } from './Stack';
import Divider from './Divider';
import { mainContentPadding } from './MainContentContainer';
import Text from './Text';
import { View } from 'react-native';

export type TitledSectionOwnProps = {
    title: string;
    centerTitle?: boolean;
    headerRight?: React.ReactNode;
};

export type TitledSectionProps = TitledSectionOwnProps & PaperProps;

const TitledSection: React.FC<TitledSectionProps> = ({ children, centerTitle, title, headerRight, ..._toPass }) => {
    return (
        <Stack
            vertical
            fullWidth
            space={contentStackSpacing}
            testID="titled-paper-root"
            style={{ marginBottom: mainContentPadding }}
        >
            <Stack vertical fullWidth style={{ marginBottom: mainContentPadding }}>
                <Stack
                    horizontal
                    fullWidth
                    justify="space-between"
                    style={{ paddingTop: mainContentPadding, paddingBottom: mainContentPadding }}
                >
                    <Text
                        alignText={centerTitle ? 'center' : undefined}
                        variant="h4"
                        style={centerTitle ? { flex: 1 } : {}}
                    >
                        {title}
                    </Text>
                    {headerRight ? <View>{headerRight || null}</View> : null}
                </Stack>
                <Divider horizontal />
            </Stack>
            {children}
        </Stack>
    );
};

export default React.memo(TitledSection);
